import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { Item as ItemType } from '@models/item';
import { Link } from '@router/Link';

import Badge from './Badge';
import styles from './styles.module.scss';

interface Props {
    shopId: string;
    item: ItemType;
}

function Item({
  item, shopId,
}:Props) {
  const {
    name, thumbnailUrl, salePrice, badges, isSoldOut, id,
  } = item;
  const { itemImageShape, itemBadgePosition } = useAppCustom().items;
  return (
        <Link activityParams={{ shopId, itemId: id }}
              className={styles.wrapper}
              activityName='ItemActivity' >
            <Column aria-label='item'
                    align='center'
                    fullWidth
                    className={styles.container} >
                <ThumbnailWrapper shape={itemImageShape}>
                    <Image src={thumbnailUrl}
                           width={120}
                           height={120}
                           alt='상품 이미지'
                           className={styles.thumbnail} />
                    {isSoldOut && (
                        <div className={styles.soldoutWrapper}>
                            <div className={styles.soldoutContainer}>
                                <div className={styles.soldout} />
                                <Text size='s' fontWeight='bold'
                                      className={styles.soldoutText} >
                                    SOLDOUT
                                </Text>
                            </div>
                        </div>
                    )}
                </ThumbnailWrapper>
                <Text className={styles.name}
                      as='div'
                      size='s'
                      align='center'>
                    {name}
                </Text>
                <Text size='lg' fontWeight='bold'>
                    {salePrice.toLocaleString()}원
                </Text>
                <div className={styles.badges}>
                    {badges?.map((badge) => (
                        <Badge key={badge}>{badge}</Badge>
                    ))}
                </div>
            </Column>
        </Link>
  );
}

const ThumbnailWrapper = styled.div<{shape: 'RECTANGLE' | 'CIRCLE'}>`
    align-items: center;
    aspect-ratio: 1;
    background-color: white;
    border-radius: ${(props) => (props.shape === 'RECTANGLE' ? '12px' : '50%')};
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.10);
    display: flex;
    justify-content: center;
    max-width: 100%;
    overflow: hidden;
    width: 100%;
    transition: 200ms;
`;

export default Item;
